import { render } from "./orderDetails.vue?vue&type=template&id=154b0bfe&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"

import "./orderDetails.vue?vue&type=style&index=0&id=154b0bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154b0bfe"]])

export default __exports__